<section>
  <div class="tw-flex tw-justify-end tw-mt-3 tw-mr-3">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
  <!-- The below component should be removed with the deprecation of the Inbox in place of the Today page -->
  <app-message-threads [borrower]="data.borrower"></app-message-threads>
</section>
